var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalgesicos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1512",
    "data-name": "Grupo 1512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.507,
    height: 51.494,
    viewBox: "0 0 51.507 51.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_147",
    "data-name": "Rect\\xE1ngulo 147",
    width: 51.507,
    height: 51.494,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1511",
    "data-name": "Grupo 1511",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_439",
    "data-name": "Trazado 439",
    d: "M47.8,5.363H42.683c-.952.005-1.55.506-1.558,1.305a1.238,1.238,0,0,0,.347.9A1.635,1.635,0,0,0,42.662,8c.991,0,1.983,0,2.973,0h2.193c.874,0,1.04.163,1.04,1.025q0,19.385,0,38.77c0,.912-.149,1.061-1.057,1.061q-9.83,0-19.663,0c-.937,0-1.077-.142-1.077-1.088V9c0-.079,0-.158,0-.237A.683.683,0,0,1,27.845,8C28.538,8,29.246,8,29.93,8l1.652,0c.6,0,1.216,0,1.825,0a1.318,1.318,0,1,0,.029-2.632c-.178-.007-.354-.005-.526,0H30.25V4.931c0-.485,0-.954,0-1.423A3.309,3.309,0,0,0,26.716,0h-13.7Q8.221,0,3.428,0A3.308,3.308,0,0,0,.106,2.487.842.842,0,0,1,.059,2.6c-.012.026-.023.052-.034.079L0,2.744V48.728l.01.04a3.584,3.584,0,0,0,2.715,2.715l.04.01H48.772l.068-.033.068-.035a.382.382,0,0,1,.056-.029,3.272,3.272,0,0,0,2.542-3.329q0-.414,0-.83V9.047c0-2.375-1.316-3.685-3.707-3.685M2.664,13.2H24.4V38.309H2.664ZM24.479,48.855H3.695c-.908,0-1.057-.149-1.057-1.058V41h21.84ZM24.434,9.025V10.5H2.638V8.095q0-2.267,0-4.533c0-.735.2-.925.943-.925h23.09c.737,0,.939.2.941.928,0,.554,0,1.106-.007,1.66v.145a3.325,3.325,0,0,0-3.171,3.656",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_440",
    "data-name": "Trazado 440",
    d: "M303.32,76.992h-.026a4.1,4.1,0,0,0-.04,8.2h.027a4.1,4.1,0,0,0,.039-8.2m-.005,5.558a1.442,1.442,0,0,1-1.045-.417,1.461,1.461,0,0,1,1.019-2.5h.01a1.461,1.461,0,0,1,.016,2.921",
    transform: "translate(-260.209 -66.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_441",
    "data-name": "Trazado 441",
    d: "M227.8,151.345a4.077,4.077,0,0,0-2.883-1.183h-.033a4.1,4.1,0,0,0-4.049,4.095v.017a4.092,4.092,0,0,0,4.1,4.083h.034a4.1,4.1,0,0,0,2.835-7.012m-4.328,2.878a1.46,1.46,0,0,1,1.454-1.424h.013a1.466,1.466,0,0,1,1.445,1.454,1.443,1.443,0,0,1-.433,1.038,1.463,1.463,0,0,1-1.042.429,1.433,1.433,0,0,1-1.024-.439,1.464,1.464,0,0,1-.413-1.058",
    transform: "translate(-192.058 -130.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_442",
    "data-name": "Trazado 442",
    d: "M306.158,151.34a4.094,4.094,0,1,0-2.865,7.017h.038a4.1,4.1,0,0,0,2.827-7.017m-3.893,3.958a1.46,1.46,0,0,1,1.023-2.5h.017a1.446,1.446,0,0,1,1.012.434,1.456,1.456,0,0,1-2.052,2.065",
    transform: "translate(-260.208 -130.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_443",
    "data-name": "Trazado 443",
    d: "M224.966,77a4.1,4.1,0,0,0-.094,8.194h.039A4.1,4.1,0,0,0,224.966,77m.988,5.123a1.458,1.458,0,0,1-2.075-2.048,1.436,1.436,0,0,1,1.024-.439h.014a1.458,1.458,0,0,1,1.037,2.487",
    transform: "translate(-192.058 -66.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_444",
    "data-name": "Trazado 444",
    d: "M227.822,224.542a4.077,4.077,0,0,0-2.905-1.21h-.008a4.1,4.1,0,0,0,.012,8.2h.009a4.114,4.114,0,0,0,4.086-4.082,4.05,4.05,0,0,0-1.193-2.9m-1.444,2.894a1.466,1.466,0,0,1-1.446,1.454h-.013a1.464,1.464,0,0,1-1.04-2.483,1.435,1.435,0,0,1,1.025-.438h.012a1.468,1.468,0,0,1,1.462,1.467",
    transform: "translate(-192.058 -194.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_445",
    "data-name": "Trazado 445",
    d: "M306.163,224.51a4.05,4.05,0,0,0-2.915-1.18,4.1,4.1,0,0,0,.046,8.2h.033a4.1,4.1,0,0,0,2.836-7.015m-3.906,3.946a1.445,1.445,0,0,1-.43-1.037,1.467,1.467,0,0,1,1.448-1.453,1.45,1.45,0,0,1,1.464,1.468,1.45,1.45,0,0,1-2.482,1.021",
    transform: "translate(-260.209 -194.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_446",
    "data-name": "Trazado 446",
    d: "M227.806,297.694a4.09,4.09,0,0,0-6.976,2.9v.005A4.1,4.1,0,0,0,224.9,304.7h.02a4.1,4.1,0,0,0,2.89-7m-2.887,4.366a1.437,1.437,0,0,1-1.029-.431,1.457,1.457,0,1,1,2.49-1.011,1.471,1.471,0,0,1-1.461,1.442",
    transform: "translate(-192.058 -257.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_447",
    "data-name": "Trazado 447",
    d: "M303.334,296.5a4.1,4.1,0,1,0-.094,8.194h.039a4.1,4.1,0,0,0,3.778-2.5,4.147,4.147,0,0,0,.319-1.575,4.1,4.1,0,0,0-4.043-4.117m-.047,5.558h0a1.471,1.471,0,0,1-1.457-1.445,1.468,1.468,0,0,1,1.461-1.477h0a1.455,1.455,0,0,1,1.449,1.485,1.46,1.46,0,0,1-1.451,1.437",
    transform: "translate(-260.208 -257.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_448",
    "data-name": "Trazado 448",
    d: "M283.963,42.52a1.321,1.321,0,0,1-1.313,1.3h0a1.326,1.326,0,0,1-1.313-1.363,1.315,1.315,0,0,1,2.629.064",
    transform: "translate(-244.679 -35.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_449",
    "data-name": "Trazado 449",
    d: "M72.521,144.189a1.343,1.343,0,0,0-1.513-1.5c-.631,0-1.261,0-1.913,0h-.546v-.56c0-.651,0-1.281,0-1.91a1.343,1.343,0,0,0-1.517-1.5q-2.038-.006-4.077,0h-.194c-1.131,0-1.614.479-1.616,1.6,0,.615,0,1.23,0,1.857v.515H60.6c-.651,0-1.283,0-1.915,0a1.343,1.343,0,0,0-1.514,1.5c0,1.4,0,2.784,0,4.319,0,1.092.491,1.579,1.588,1.582.612,0,1.225,0,1.853,0h.533c0,.192,0,.382,0,.571,0,.7,0,1.355,0,2.025a1.3,1.3,0,0,0,1.337,1.371c.78.007,1.57.01,2.361.01s1.575,0,2.361-.01a1.306,1.306,0,0,0,1.339-1.367c.009-.511.008-1.029.005-1.531,0-.22,0-.439,0-.658v-.41h.564c.658,0,1.289,0,1.919,0a1.335,1.335,0,0,0,1.488-1.479c.005-1.338.005-2.784,0-4.419m-8.74,4.868c0-1.123-.483-1.6-1.61-1.605-.6,0-1.2,0-1.815,0H59.83v-2.129h2.358c1.1,0,1.59-.487,1.592-1.574,0-.616,0-1.233,0-1.857v-.513h2.129v1.57c0,.1,0,.2,0,.3,0,.229,0,.466.005.7a1.314,1.314,0,0,0,1.382,1.369c.659.008,1.305.007,1.991,0h.555v2.13H67.678c-1.337,0-1.765.425-1.767,1.748v2.186H63.782V150.9q0-.92,0-1.842",
    transform: "translate(-49.721 -120.639)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalgesicos);
export default __webpack_public_path__ + "static/media/analgesicos.9afced527a9e32f60df21f14aa848935.svg";
export { ForwardRef as ReactComponent };